import React from 'react';
import { connect } from 'react-redux';
import UserList from '../UserList/UserList';
import UserReportList from '../UserReportsList/UserReportsList';
import AttachFiles from '../AttachFiles/AttachFiles';
import Preloader from '../../Preloader/Preloader';
import ReportsWrapper from './Reports.style';
import { getUserList, getUserReportList, fetchConversationData, setConversationUser, setConversationReport, toggleConversationPopup, fetchReportFiles, toggleAttachPopup } from '../../../redux/actions/Box/BoxActions';

class Reports extends React.Component {

  constructor() {
    super();
    this.getUserReports = this.getUserReports.bind(this);
    this.getReportFiles = this.getReportFiles.bind(this);
  }

  componentDidMount() {
    this.props.setConversationUser({ id: 0 });
    this.props.setConversationReport({ id: 0 });
    this.props.getUserList(this.props.from);
  }

  getUserReports(user,from) {
    this.props.setConversationUser(user);
    this.props.getUserReportList(user.id,from);
  }

  getReportFiles(report) {
    this.props.setConversationReport(report);
    this.props.fetchReportFiles(this.props.BOXREDUCER.conversation_user.id,report.report_id);
  }

  attachReports() {
    console.log('attach reports nw');
  }
  
  render() {
    if(this.props.APPREDUCER.showPreloader === true) {
      return(
        <Preloader />
      )
    }
    else {

      let report_view;
      
      if(this.props.BOXREDUCER.conversation_user.id === 0) {
        const box_user_list = this.props.BOXREDUCER.user_list;
        report_view = <UserList
                      data={box_user_list}
                      from='reports'
                      getUserReports={this.getUserReports}
                      setUser={null}
                    />;
      }
      else {
        const box_user_report_list = this.props.BOXREDUCER.user_report_list;
        report_view = <UserReportList
                      data={box_user_report_list}
                      from='reports'
                      getConversationData={null}
                      toggleConversationPopup={null}
                      setConversationUser={this.props.setConversationUser}
                      user={this.props.BOXREDUCER.conversation_user}
                      getReportFiles={this.getReportFiles}
                      toggleAttachPopup={this.props.toggleAttachPopup}
                    />;
      }
      return(
        <ReportsWrapper>
          {report_view}
          <AttachFiles />
        </ReportsWrapper>
      )

    }
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  getUserList,
  getUserReportList,
  fetchConversationData,
  setConversationUser,
  setConversationReport,
  toggleConversationPopup,
  fetchReportFiles,
  toggleAttachPopup
};

export default connect(mapStateToProps, mapDispatchToProps)(Reports);


// WEBPACK FOOTER //
// ./src/components/Box/Reports/Reports.js